export default {
    PleaseEnterSupplierName: "Por favor insira o nome da loja",
    pleaseSelectMainBusinessCategory: "Selecione a categoria principal de negócios",
    pleaseEnterContactName: "Por favor insira o nome do contato",
    pleaseEnterContactPhoneNumber: "Insira o número de telefone de contato",
    pleaseEnterDetailedAddress: "Por favor insira o endereço detalhado",
    pleaseSetYourPassword: "Por favor, defina a senha",
    pleaseConfirmPassword: "Por favor confirme a senha",
    NeedProvideBusinessLicense: "(forneça licença comercial)",
    pleaseEnterTheNameOfLegalPerson: "Insira o nome da pessoa jurídica",
    pleaseEnterThePhoneNumber: "Por favor, insira o número de telefone",
    pleaseEnterLegalPersonsIDCard: "Insira o cartão de identificação de pessoa jurídica",
    pleaseEnterUnifiedSocialCreditCode: "Insira o código de crédito social unificado",
    pleaseSelectDate: "Selecione a data",
    MustContainCombinationUppercaseNLowercaseLettersNNumbers: "Deve conter letras maiúsculas e minúsculas e números. O comprimento está entre 6 e 20 e caracteres especiais não podem ser usados!",
    pleaseEnterTheAdminsPhoneNumber: "Insira o número de telefone do administrador",
    threeToThirtyCharactersInLength: "Três a trinta caracteres de comprimento",
    pleaseEnterTheNameOfTheAdmin: "Por favor, digite o nome do TheAdmin",
    pleaseEnterThePassword: "Por favor insira a senha",
    pleaseEnterAccAndPsw: "Por favor insira seu número de conta e senha",
    pleaseEnterPasswordAgain: "Por favor digite a senha novamente",
    theTwoPasswordsRInconsistent: "As duas senhas inconsistentes!",
    pleaseEnterTheWarehouseAddress: "Por favor, insira o endereço do armazém",
    pleaseEnterTheLegalPersonPhoneNumber: "Insira o número de telefone da pessoa jurídica",
    pleaseEnterTheLegalPersonIDNumber: "Insira o número de identificação da pessoa jurídica",
    pleaseUploadBusinessLicense: "Faça upload da licença comercial",
    pleaseUploadID: "Faça upload do ID",
    pleaseFillInTheBusinessPeriod: "Preencha o período comercial",
    pleaseFillTheUnifiedScialCreditCode: "Preencha o Código de Crédito Social Unificado"
}